export const colors = {
  white: '#FFFFFF',
  black: '#000000',
  gray: {
    lighter: '#EDEDED',
    light: '#999999',
    medium: '#777777',
    mediumDark: '#444444',
    dark: '#555555',
    darker: '#222222',
    default: '#DADADA'
  },
  cyan: {
    lighter: '#D8EEF6',
    light: '#E0F8F9',
    default: '#01878E',
    medium: '#028BB7'
  },
  blue: {
    lighter: '#F0F3F8'
  },
  red: {
    dark: '#C80E3B'
  },
  yellow: {
    medium: '#FAECCA',
    dark: '#EFB520'
  },
  transparent: 'transparent',
  vet: {
    iconBorderColor: '#FFF2EE'
  }
}

export const buttonSizes = {
  small: '32px',
  medium: '40px',
  default: '48px',
  big: '56px'
}
